const requiredFields = [
  "person_type",
  "firstName",
  "lastName",
  "cpf_cnpj",
  "telephone",
  "cellphone",
  "email",
  "zipcode",
  "street",
  "number",
  "neighborhood",
  "city",
  "state",
];

const fieldLabels = {
  person_type: "Selecione o tipo de conta.",
  firstName: "Informe o nome da conta ou empresa.",
  lastName: "Informe o nome do responsável.",
  cpf_cnpj: "Informe o documento.",
  telephone: "Informe o telefone comercial.",
  cellphone: "Informe o celular ou WhatsApp.",
  email: "Informe o e-mail.",
  zipcode: "Informe o CEP.",
  street: "Informe a rua.",
  number: "Informe o número.",
  neighborhood: "Informe o bairro.",
  city: "Informe a cidade.",
  state: "Informe a UF.",
};

function hasValue(value) {
  return String(value ?? "").trim().length > 0;
}

function onlyNumbers(value) {
  return String(value || "").replace(/\D/g, "");
}

export function validateCompleteSignupForm(formData) {
  const errors = {};

  requiredFields.forEach((fieldName) => {
    if (!hasValue(formData[fieldName])) {
      errors[fieldName] = fieldLabels[fieldName] || "Campo obrigatório.";
    }
  });

  if (hasValue(formData.email) && !/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = "Informe um e-mail válido.";
  }

  const documentDigits = onlyNumbers(formData.cpf_cnpj);

  if (
    hasValue(formData.cpf_cnpj) &&
    ((formData.person_type === "PJ" && documentDigits.length !== 14) ||
      (formData.person_type !== "PJ" && documentDigits.length !== 11))
  ) {
    errors.cpf_cnpj =
      formData.person_type === "PJ" ? "Informe um CNPJ válido." : "Informe um CPF válido.";
  }

  if (hasValue(formData.zipcode) && onlyNumbers(formData.zipcode).length !== 8) {
    errors.zipcode = "Informe um CEP válido.";
  }

  if (hasValue(formData.state) && String(formData.state).trim().length !== 2) {
    errors.state = "Use a sigla da UF.";
  }

  return errors;
}

export function getFirstCompleteSignupError(errors) {
  return requiredFields.find((fieldName) => Boolean(errors[fieldName]));
}
